import { Inspect } from '../../../../components/Inspect'
import { reviewHhsPrograms } from '../../../../utilities'

export const InspectOther = ({ goBackToPage, pages, values }) => {
  const allegationDetails = reviewHhsPrograms(values)

  return Inspect({ goBackToPage, pages, values, allegationDetails })
}
